import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupCreateV2" */ './lazyIndex'),
    { name: 'GroupCreateV2' }
);

// Exported actions
export const lazyCreateGroupV2: LazyImport<typeof lazyIndex.createGroup, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.createGroup);
